/* ========================================
   BK-MEDIA JAVASCRIPT FUNCTIONALITY
   ======================================== */

(function() {
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.includes('cart/add.js') && options && options.body instanceof FormData) {
      options.body.delete('properties[Schnürsenkel Bild]');
    }
    return originalFetch.apply(this, arguments);
  };
})();

document.addEventListener('DOMContentLoaded', function() {
  console.log('BK-Media JS: DOM Content Loaded');
  
  // Collapsible Description Functionality
  initCollapsibleDescriptions();
  
  // Audio Player Functionality
  initAudioPlayers();
  
  // Product Configurator Functionality
  initProductConfigurator();
  
  // Video Popup Functionality
  initVideoPopup();
  
  // Gallery Collapse Functionality
  initGalleryCollapse();
  
  // FAQ Accordion Functionality
  initFaqAccordions();

  initSavedConfigsDrawer();
  updateSavedConfigsHeaderCount();
});

document.addEventListener('click', function(event) {
  const wunschbildLink = event.target.closest('.bk-media-line-item-wunschbild__link');
  if (wunschbildLink) {
    const url = wunschbildLink.getAttribute('data-url');
    if (url) window.open(url, '_blank', 'noopener');
  }
});

document.addEventListener('keydown', function(event) {
  const wunschbildLink = event.target.closest('.bk-media-line-item-wunschbild__link');
  if (wunschbildLink && (event.key === 'Enter' || event.key === ' ')) {
    event.preventDefault();
    const url = wunschbildLink.getAttribute('data-url');
    if (url) window.open(url, '_blank', 'noopener');
  }
});

// Also initialize when the page is fully loaded
window.addEventListener('load', function() {
  console.log('BK-Media JS: Window Loaded');
  initProductConfigurator();
});

function initCollapsibleDescriptions() {
  const descriptions = document.querySelectorAll('.bk-media-collapsible-description');
  
  descriptions.forEach(description => {
    const content = description.querySelector('.bk-media-collapsible-description__content');
    const toggle = description.querySelector('.bk-media-collapsible-description__toggle');
    
    if (!content || !toggle) return;
    
    // Check if content is longer than 2.5 lines
    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    const maxHeight = lineHeight * 2.5;
    const contentHeight = content.scrollHeight;
    
    if (contentHeight <= maxHeight) {
      // Content is short enough, hide toggle
      toggle.style.display = 'none';
      return;
    }
    
    // Initialize as collapsed
    content.classList.add('collapsed');
    toggle.setAttribute('aria-expanded', 'false');
    
    // Add click event listener
    toggle.addEventListener('click', function() {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const textElement = toggle.querySelector('.bk-media-collapsible-description__toggle-text');
      
      if (isExpanded) {
        // Collapse
        content.classList.add('collapsed');
        toggle.setAttribute('aria-expanded', 'false');
        textElement.textContent = 'Mehr lesen';
      } else {
        // Expand
        content.classList.remove('collapsed');
        toggle.setAttribute('aria-expanded', 'true');
        textElement.textContent = 'Weniger lesen';
      }
    });
  });
}

function initAudioPlayers() {
  const audioPlayers = document.querySelectorAll('.bk-media-audio-player');
  
  audioPlayers.forEach(player => {
    const playBtn = player.querySelector('.bk-media-audio-player__play-btn');
    const audio = player.querySelector('.bk-media-audio-player__audio');
    const playIcon = player.querySelector('.bk-media-audio-player__play-icon');
    const waveformBars = player.querySelectorAll('.bk-media-audio-player__waveform-bar');
    const waveform = player.querySelector('.bk-media-audio-player__waveform');
    
    if (!playBtn || !audio || !playIcon) return;
    
    // Initialize waveform bars with their heights (mirrored effect)
    waveformBars.forEach(bar => {
      const height = bar.getAttribute('data-height');
      const topHeight = height / 2;
      const bottomHeight = height / 2;
      
      // Create pseudo-elements for top and bottom parts
      bar.style.position = 'relative';
      bar.style.height = `${height}%`;
      bar.style.background = 'transparent';
      
      // Create top part
      const topPart = document.createElement('div');
      topPart.style.position = 'absolute';
      topPart.style.top = '50%';
      topPart.style.left = '0';
      topPart.style.width = '100%';
      topPart.style.height = `${topHeight}%`;
      topPart.style.background = 'rgba(129, 30, 60, 0.3)';
      topPart.style.transform = 'translateY(-100%)';
      topPart.className = 'waveform-bar-top';
      
      // Create bottom part
      const bottomPart = document.createElement('div');
      bottomPart.style.position = 'absolute';
      bottomPart.style.top = '50%';
      bottomPart.style.left = '0';
      bottomPart.style.width = '100%';
      bottomPart.style.height = `${bottomHeight}%`;
      bottomPart.style.background = 'rgba(129, 30, 60, 0.3)';
      bottomPart.style.transform = 'translateY(0)';
      bottomPart.className = 'waveform-bar-bottom';
      
      bar.appendChild(topPart);
      bar.appendChild(bottomPart);
    });
    
    // Stop all other audio players when one starts playing
    function stopAllOtherPlayers() {
      audioPlayers.forEach(otherPlayer => {
        if (otherPlayer !== player) {
          const otherAudio = otherPlayer.querySelector('.bk-media-audio-player__audio');
          const otherPlayBtn = otherPlayer.querySelector('.bk-media-audio-player__play-btn');
          const otherPlayIcon = otherPlayer.querySelector('.bk-media-audio-player__play-icon');
          
          if (otherAudio && otherPlayBtn && otherPlayIcon) {
            otherAudio.pause();
            otherAudio.currentTime = 0;
            otherPlayer.classList.remove('playing');
            otherPlayBtn.classList.remove('playing');
            otherPlayIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
          }
        }
      });
    }
    
    playBtn.addEventListener('click', function() {
      if (audio.paused) {
        // Stop all other players first
        stopAllOtherPlayers();
        
        // Play current audio
        audio.play().then(() => {
          player.classList.add('playing');
          playBtn.classList.add('playing');
          playIcon.innerHTML = '<path d="M6 4H10V20H6V4ZM14 4H18V20H14V4Z" fill="currentColor"/>';
        }).catch(error => {
          console.error('Error playing audio:', error);
        });
      } else {
        // Pause current audio
        audio.pause();
        player.classList.remove('playing');
        playBtn.classList.remove('playing');
        playIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
      }
    });
    
    // Update waveform
    function updateProgress() {
      if (audio.duration && audio.readyState >= 1) {
        const progress = (audio.currentTime / audio.duration) * 100;
        
        // Update waveform bars based on progress with higher precision
        const barsCount = waveformBars.length;
        const playedBarsCount = Math.floor((progress / 100) * barsCount);
        
        waveformBars.forEach((bar, index) => {
          const topPart = bar.querySelector('.waveform-bar-top');
          const bottomPart = bar.querySelector('.waveform-bar-bottom');
          
          // More precise calculation for partial progress
          const barProgress = ((progress / 100) * barsCount) - index;
          const isActive = index < playedBarsCount;
          const isPartiallyActive = index === playedBarsCount && barProgress > 0;
          
          if (isActive) {
            // Fully played bars
            if (topPart) topPart.style.background = '#811E3C';
            if (bottomPart) bottomPart.style.background = '#811E3C';
            bar.classList.add('played');
          } else if (isPartiallyActive) {
            // Partially played bar (for more accurate visualization)
            const opacity = Math.max(0.3, barProgress);
            if (topPart) topPart.style.background = `rgba(129, 30, 60, ${opacity})`;
            if (bottomPart) bottomPart.style.background = `rgba(129, 30, 60, ${opacity})`;
            bar.classList.add('played');
          } else {
            // Unplayed bars
            if (topPart) topPart.style.background = 'rgba(129, 30, 60, 0.3)';
            if (bottomPart) bottomPart.style.background = 'rgba(129, 30, 60, 0.3)';
            bar.classList.remove('played');
          }
        });
      }
    }
    
    // Handle time update
    audio.addEventListener('timeupdate', updateProgress);
    
    // Handle audio end
    audio.addEventListener('ended', function() {
      player.classList.remove('playing');
      playBtn.classList.remove('playing');
      playIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
      
      // Reset all waveform bars
      waveformBars.forEach(bar => {
        const topPart = bar.querySelector('.waveform-bar-top');
        const bottomPart = bar.querySelector('.waveform-bar-bottom');
        if (topPart) topPart.style.background = 'rgba(129, 30, 60, 0.3)';
        if (bottomPart) bottomPart.style.background = 'rgba(129, 30, 60, 0.3)';
        bar.classList.remove('played');
      });
    });
    
    // Handle audio error
    audio.addEventListener('error', function() {
      console.error('Audio playback error for:', audio.src);
      player.classList.remove('playing');
      playBtn.classList.remove('playing');
      playIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
      
      // Reset all waveform bars
      waveformBars.forEach(bar => {
        const topPart = bar.querySelector('.waveform-bar-top');
        const bottomPart = bar.querySelector('.waveform-bar-bottom');
        if (topPart) topPart.style.background = 'rgba(129, 30, 60, 0.3)';
        if (bottomPart) bottomPart.style.background = 'rgba(129, 30, 60, 0.3)';
        bar.classList.remove('played');
      });
    });
    
    // Reset progress when paused
    audio.addEventListener('pause', function() {
      if (audio.currentTime === 0) {
        waveformBars.forEach(bar => {
          const topPart = bar.querySelector('.waveform-bar-top');
          const bottomPart = bar.querySelector('.waveform-bar-bottom');
          if (topPart) topPart.style.background = 'rgba(129, 30, 60, 0.3)';
          if (bottomPart) bottomPart.style.background = 'rgba(129, 30, 60, 0.3)';
          bar.classList.remove('played');
        });
      }
    });
    
    // Add click functionality to waveform for seeking
    if (waveform) {
      waveform.addEventListener('click', function(e) {
        if (audio.duration && audio.readyState >= 1) {
          const rect = waveform.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          
          // Ensure click is within bounds
          const boundedX = Math.max(0, Math.min(clickX, rect.width));
          const clickPercentage = boundedX / rect.width;
          const newTime = clickPercentage * audio.duration;
          
          // Show seeking indicator
          waveform.classList.add('seeking');
          waveform.style.setProperty('--seek-position', `${clickPercentage * 100}%`);
          
          // Set the new time with precision
          audio.currentTime = Math.max(0, Math.min(newTime, audio.duration));
          
          // Update the waveform immediately
          updateProgress();
          
          // Hide seeking indicator after a short delay
          setTimeout(() => {
            waveform.classList.remove('seeking');
          }, 300);
          
          // Force a small visual update to ensure accuracy
          requestAnimationFrame(() => {
            updateProgress();
          });
        }
      });
      
      // Add touch support for mobile devices
      waveform.addEventListener('touchstart', function(e) {
        e.preventDefault();
      });
      
      waveform.addEventListener('touchend', function(e) {
        e.preventDefault();
        if (audio.duration && audio.readyState >= 1) {
          const rect = waveform.getBoundingClientRect();
          const touch = e.changedTouches[0];
          const clickX = touch.clientX - rect.left;
          
          // Ensure click is within bounds
          const boundedX = Math.max(0, Math.min(clickX, rect.width));
          const clickPercentage = boundedX / rect.width;
          const newTime = clickPercentage * audio.duration;
          
          // Show seeking indicator
          waveform.classList.add('seeking');
          waveform.style.setProperty('--seek-position', `${clickPercentage * 100}%`);
          
          // Set the new time with precision
          audio.currentTime = Math.max(0, Math.min(newTime, audio.duration));
          
          // Update the waveform immediately
          updateProgress();
          
          // Hide seeking indicator after a short delay
          setTimeout(() => {
            waveform.classList.remove('seeking');
          }, 300);
          
          // Force a small visual update to ensure accuracy
          requestAnimationFrame(() => {
            updateProgress();
          });
        }
      });
      
      // Add cursor pointer style
      waveform.style.cursor = 'pointer';
    }
  });
}

/* ========================================
   PRODUCT CONFIGURATOR FUNCTIONALITY
   ======================================== */

let currentStep = 1;
let totalSteps = 4;
let configuratorListenersAttached = false;

function initProductConfigurator() {
  console.log('BK-Media: Initializing product configurator...');
  
  // Initialize inline product configurator
  initInlineProductConfigurator();
  
  const drawer = document.querySelector('.bk-media-configurator-drawer');
  if (!drawer) {
    console.log('BK-Media: Drawer not found, skipping configurator initialization');
    return;
  }
  
  const hasGlitzer = drawer.getAttribute('data-has-glitzer') === 'true';
  const hasSchnuersenkel = drawer.querySelector('.bk-media-configurator-modal__schnuersenkel') !== null;
  const hasDatumStep = drawer.getAttribute('data-has-datum-step') === 'true';
  const hasWunschbild = document.getElementById('config-wunschbild-input') !== null;
  
  console.log('BK-Media: Configurator setup - hasGlitzer:', hasGlitzer, 'hasSchnuersenkel:', hasSchnuersenkel, 'hasDatumStep:', hasDatumStep, 'hasWunschbild:', hasWunschbild);
  
  // Calculate total steps based on available features
  totalSteps = 1; // Schuhgröße (always present)
  if (hasGlitzer) totalSteps++; // Glitzer step
  totalSteps++; // Namen step (always present)
  if (hasDatumStep) totalSteps++; // Datum step (conditional)
  totalSteps++; // Zusätze step (always present)
  if (hasWunschbild) totalSteps++; // Wunschbild step (image upload)
  if (hasSchnuersenkel) totalSteps++; // Schnürsenkel step (conditional)
  
  console.log('BK-Media: Total steps set to:', totalSteps);
  
  console.log('BK-Media: Drawer found, setting up configurator');
  
  // Set initial step
  updateStepDisplay();

  setupDateInputPlaceholders();
  initWunschbildUpload();

  if (!configuratorListenersAttached) {
    configuratorListenersAttached = true;

  document.addEventListener('click', function(event) {
    const button = event.target.closest('button[aria-controls]');
    if (button && button.getAttribute('aria-controls') && button.getAttribute('aria-controls').includes('product-configurator-drawer')) {
      event.preventDefault();
      const drawerId = button.getAttribute('aria-controls');
      const drawer = document.getElementById(drawerId);
      if (drawer && drawer.open) {
        drawer.open();
        button.setAttribute('aria-expanded', 'true');
        currentStep = 1;
        updateStepDisplay();
        setupDateInputPlaceholders();
        checkAndShowLoadSaved();
      }
    }
  });

  document.addEventListener('drawer:close', function(event) {
    const drawer = event.target;
    if (drawer && drawer.id && drawer.id.includes('product-configurator-drawer')) {
      resetConfigurator();
      const button = document.querySelector(`button[aria-controls="${drawer.id}"]`);
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    }
  });

  document.addEventListener('click', function(event) {
    const option = event.target.closest('.bk-media-configurator-modal__option');
    if (option) {
      const value = option.getAttribute('data-value');
      const parentStep = option.closest('.bk-media-configurator-modal__step-content');
      
      if (parentStep) {
        // Remove selected class from all options in this step
        const allOptions = parentStep.querySelectorAll('.bk-media-configurator-modal__option');
        allOptions.forEach(opt => opt.classList.remove('selected'));
        
        // Add selected class to clicked option
        option.classList.add('selected');
        
        // Determine which input to update based on the step
        let hiddenInput;
        if (parentStep.querySelector('#config-glitzer')) {
          hiddenInput = document.getElementById('config-glitzer');
        } else if (parentStep.querySelector('#config-upsell')) {
          hiddenInput = document.getElementById('config-upsell');
        }
        
        if (hiddenInput) {
          // Set the value in hidden input
          hiddenInput.value = value;
          
          // Clear any error
          clearFieldError(hiddenInput);
        }
      }
    }
  });
  
  document.addEventListener('click', function(event) {
    const schnuersenkelOption = event.target.closest('.bk-media-configurator-modal__schnuersenkel-option-image');
    if (schnuersenkelOption) {
      const value = schnuersenkelOption.getAttribute('data-value');
      const parentRow = schnuersenkelOption.closest('.bk-media-configurator-modal__schnuersenkel-option-row');
      
      if (parentRow) {
        const allRows = parentRow.parentElement.querySelectorAll('.bk-media-configurator-modal__schnuersenkel-option-row');
        const rowIndex = Array.from(allRows).indexOf(parentRow);
        const hiddenInput = document.getElementById(`config-schnuersenkel-option${rowIndex + 1}`);
        const isAlreadySelected = schnuersenkelOption.classList.contains('selected');
        
        if (isAlreadySelected) {
          schnuersenkelOption.classList.remove('selected');
          if (hiddenInput) hiddenInput.value = '';
        } else {
          const allRowOptions = parentRow.querySelectorAll('.bk-media-configurator-modal__schnuersenkel-option-image');
          allRowOptions.forEach(opt => opt.classList.remove('selected'));
          schnuersenkelOption.classList.add('selected');
          if (hiddenInput) hiddenInput.value = value;
        }
        if (hiddenInput) clearFieldError(hiddenInput);
        updateSchnuersenkelAddPriceDisplay();
      }
    }
  });
  
  
  // Add event listeners for read more functionality
  document.addEventListener('click', function(event) {
    const loadSavedBtn = event.target.closest('#config-load-saved-btn');
    if (loadSavedBtn) {
      event.preventDefault();
      loadConfigFromStorage();
    }
    const saveBtn = event.target.closest('#config-save-btn');
    if (saveBtn) {
      event.preventDefault();
      saveConfigToStorage();
    }
  });

  document.addEventListener('click', function(event) {
    const readMoreBtn = event.target.closest('[data-read-more]');
    if (readMoreBtn) {
      const container = readMoreBtn.closest('.bk-media-configurator-modal__upsell-text-container');
      const shortText = container.querySelector('.bk-media-configurator-modal__upsell-text');
      const fullText = container.querySelector('.bk-media-configurator-modal__upsell-full-text');
      
      if (shortText && fullText) {
        if (shortText.style.display !== 'none') {
          // Show full text
          shortText.style.display = 'none';
          fullText.style.display = 'block';
          readMoreBtn.textContent = 'Weniger anzeigen';
        } else {
          // Show short text
          shortText.style.display = 'block';
          fullText.style.display = 'none';
          readMoreBtn.textContent = 'Mehr anzeigen';
        }
      }
    }
  });
  }

  console.log('BK-Media: Product configurator initialized successfully');
}

function openProductConfigurator(event) {
  if (event) {
    event.preventDefault();
  }
  
  console.log('Opening product configurator...');
  
  const drawer = event?.target?.closest('button[aria-controls]')?.getAttribute('aria-controls');
  const drawerElement = drawer ? document.getElementById(drawer) : document.querySelector('.bk-media-configurator-drawer');
  
  if (drawerElement && drawerElement.open) {
    drawerElement.open();
    const button = document.querySelector(`button[aria-controls="${drawerElement.id}"]`);
    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
    currentStep = 1;
    updateStepDisplay();
    setupDateInputPlaceholders();
    console.log('Drawer opened successfully');
  } else {
    console.error('Product configurator drawer not found');
  }
}

function closeProductConfigurator() {
  const drawer = document.querySelector('.bk-media-configurator-drawer');
  if (drawer) {
    // Try multiple methods to close the drawer
    if (drawer.close && typeof drawer.close === 'function') {
      drawer.close();
    } else if (drawer.hasAttribute && drawer.hasAttribute('open')) {
      drawer.removeAttribute('open');
    } else if (drawer.setAttribute) {
      drawer.setAttribute('open', 'false');
    }
    
    // Update button state
    const button = document.querySelector(`button[aria-controls="${drawer.id}"]`);
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
    
    resetConfigurator();
  }
}

function initWunschbildUpload() {
  const input = document.getElementById('config-wunschbild-input');
  const urlInput = document.getElementById('config-wunschbild-url');
  const preview = document.getElementById('config-wunschbild-preview');
  const previewImg = document.getElementById('config-wunschbild-preview-img');
  const removeBtn = document.getElementById('config-wunschbild-remove');
  const statusEl = document.getElementById('config-wunschbild-status');
  
  if (!input || !urlInput) return;
  
  input.addEventListener('change', async function() {
    const file = this.files[0];
    if (!file) return;
    
    const drawer = document.querySelector('.bk-media-configurator-drawer');
    const apiKey = drawer?.getAttribute('data-imgbb-key') || '';
    
    if (!apiKey) {
      if (statusEl) statusEl.textContent = 'Bitte ImgBB API-Schlüssel in den Theme-Einstellungen hinterlegen.';
      return;
    }
    
    if (statusEl) statusEl.textContent = 'Wird hochgeladen...';
    if (preview) preview.style.display = 'none';
    urlInput.value = '';
    
    try {
      const formData = new FormData();
      formData.append('key', apiKey);
      formData.append('image', file);
      
      const response = await fetch('https://api.imgbb.com/1/upload', {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      if (data.success && data.data && data.data.url) {
        urlInput.value = data.data.url;
        if (previewImg) previewImg.src = data.data.display_url || data.data.url;
        if (preview) preview.style.display = 'block';
        if (statusEl) statusEl.textContent = 'Bild erfolgreich hochgeladen.';
      } else {
        if (statusEl) statusEl.textContent = data.error?.message || 'Upload fehlgeschlagen.';
      }
    } catch (err) {
      console.error('ImgBB upload error:', err);
      if (statusEl) statusEl.textContent = 'Upload fehlgeschlagen. Bitte erneut versuchen.';
    }
  });
  
  if (removeBtn) {
    removeBtn.addEventListener('click', function() {
      input.value = '';
      urlInput.value = '';
      if (previewImg) previewImg.src = '';
      if (preview) preview.style.display = 'none';
      if (statusEl) statusEl.textContent = '';
    });
  }
}

function setupDateInputPlaceholders() {
  const dateInputs = document.querySelectorAll('.bk-media-configurator-modal__input[type="date"]');
  
  function updateDatePlaceholder(input) {
    const wrapper = input.closest('.bk-media-configurator-modal__date-wrapper');
    if (wrapper) {
      if (input.value) {
        wrapper.classList.add('has-value');
        wrapper.classList.remove('is-empty');
      } else {
        wrapper.classList.remove('has-value');
        wrapper.classList.add('is-empty');
      }
    }
  }
  
  dateInputs.forEach(input => {
    updateDatePlaceholder(input);
    
    input.addEventListener('change', () => updateDatePlaceholder(input));
    input.addEventListener('input', () => updateDatePlaceholder(input));
    input.addEventListener('blur', () => updateDatePlaceholder(input));
  });
}

function resetConfigurator() {
  currentStep = 1;
  
  const inputs = document.querySelectorAll('.bk-media-configurator-modal__input, .bk-media-configurator-modal__select, .bk-media-configurator-modal__textarea');
  inputs.forEach(input => {
    input.value = '';
    input.classList.remove('error');
    
    if (input.type === 'date') {
      const wrapper = input.closest('.bk-media-configurator-modal__date-wrapper');
      if (wrapper) {
        wrapper.classList.remove('has-value');
        wrapper.classList.add('is-empty');
      }
    }
  });
  
  const schnuersenkelOption1 = document.getElementById('config-schnuersenkel-option1');
  const schnuersenkelOption2 = document.getElementById('config-schnuersenkel-option2');
  if (schnuersenkelOption1) schnuersenkelOption1.value = '';
  if (schnuersenkelOption2) schnuersenkelOption2.value = '';
  const schnuersenkelImages = document.querySelectorAll('.bk-media-configurator-modal__schnuersenkel-option-image');
  schnuersenkelImages.forEach(img => img.classList.remove('selected'));
  
  const wunschbildInput = document.getElementById('config-wunschbild-input');
  const wunschbildUrl = document.getElementById('config-wunschbild-url');
  const wunschbildPreview = document.getElementById('config-wunschbild-preview');
  const wunschbildStatus = document.getElementById('config-wunschbild-status');
  if (wunschbildInput) wunschbildInput.value = '';
  if (wunschbildUrl) wunschbildUrl.value = '';
  if (wunschbildPreview) {
    wunschbildPreview.style.display = 'none';
    const img = wunschbildPreview.querySelector('img');
    if (img) img.src = '';
  }
  if (wunschbildStatus) wunschbildStatus.textContent = '';
  
  updateStepDisplay();
}

const CONFIG_STORAGE_KEY = 'bk_config_';

function getConfigData() {
  const drawer = document.querySelector('.bk-media-configurator-drawer');
  const hasGlitzer = drawer ? drawer.getAttribute('data-has-glitzer') === 'true' : false;
  const has3DatumFelder = drawer ? drawer.getAttribute('data-has-3-datum-felder') === 'true' : false;
  const has2NamenFelder = drawer ? drawer.getAttribute('data-has-2-namen-felder') === 'true' : false;
  const hasDatumStep = drawer ? drawer.getAttribute('data-has-datum-step') === 'true' : false;

  let names = '';
  if (has2NamenFelder) {
    const name1 = document.getElementById('config-name-1');
    const name2 = document.getElementById('config-name-2');
    names = `${name1 ? name1.value : ''} & ${name2 ? name2.value : ''}`;
  } else {
    const namesEl = document.getElementById('config-names');
    names = namesEl ? namesEl.value : '';
  }

  const shoeSize = document.getElementById('config-shoe-size');
  const additional = document.getElementById('config-additional');
  const config = {
    shoeSize: shoeSize ? shoeSize.value : '',
    names: names,
    additional: additional ? additional.value : ''
  };

  if (hasGlitzer) {
    const glitzer = document.getElementById('config-glitzer');
    config.glitzer = glitzer ? glitzer.value : '';
  }
  if (hasDatumStep) {
    if (has3DatumFelder) {
      const d1 = document.getElementById('config-date-1');
      const d2 = document.getElementById('config-date-2');
      const d3 = document.getElementById('config-date-3');
      if (d1) config.date1 = d1.value;
      if (d2) config.date2 = d2.value;
      if (d3) config.date3 = d3.value;
    } else {
      const d = document.getElementById('config-date');
      if (d) config.date = d.value;
    }
  }

  const opt1 = document.getElementById('config-schnuersenkel-option1');
  const opt2 = document.getElementById('config-schnuersenkel-option2');
  if (opt1 && opt1.value) config.schnuersenkelOption1 = opt1.value;
  if (opt2 && opt2.value) config.schnuersenkelOption2 = opt2.value;
  config.schnuersenkelAdd = !!(opt1?.value && opt2?.value);

  const wunschbild = document.getElementById('config-wunschbild-url');
  if (wunschbild && wunschbild.value) config.wunschbild = wunschbild.value;

  return config;
}

function saveConfigToStorage() {
  if (!validateCurrentStep()) return;

  const drawer = document.querySelector('.bk-media-configurator-drawer');
  const productId = drawer?.getAttribute('data-product-id');
  const productTitle = drawer?.getAttribute('data-product-title');
  const productUrl = drawer?.getAttribute('data-product-url');
  const productImage = drawer?.getAttribute('data-product-image');
  const variantId = drawer?.getAttribute('data-variant-id');
  const upsellVariantId = drawer?.getAttribute('data-upsell-variant');

  if (!productId) return;

  const productForm = document.querySelector('form[is="product-form"]');
  const formVariantInput = productForm?.querySelector('input[name="id"]');
  const currentVariantId = formVariantInput?.value || variantId;

  const config = getConfigData();
  const payload = {
    productId,
    productTitle: productTitle || '',
    productUrl: productUrl || '',
    productImage: productImage || '',
    variantId: currentVariantId || '',
    upsellVariantId: config.schnuersenkelAdd ? (upsellVariantId || '') : '',
    config,
    savedAt: new Date().toISOString()
  };

  try {
    localStorage.setItem(CONFIG_STORAGE_KEY + productId, JSON.stringify(payload));
    showConfiguratorSaveConfirmation();
    updateSavedConfigsHeaderCount();
  } catch (e) {
    showConfiguratorSaveError();
  }
}

function loadConfigFromStorage() {
  const drawer = document.querySelector('.bk-media-configurator-drawer');
  const productId = drawer?.getAttribute('data-product-id');
  if (!productId) return;

  try {
    const raw = localStorage.getItem(CONFIG_STORAGE_KEY + productId);
    if (!raw) return;

    const { config } = JSON.parse(raw);
    const hasGlitzer = drawer?.getAttribute('data-has-glitzer') === 'true';
    const has3DatumFelder = drawer?.getAttribute('data-has-3-datum-felder') === 'true';
    const has2NamenFelder = drawer?.getAttribute('data-has-2-namen-felder') === 'true';
    const hasDatumStep = drawer?.getAttribute('data-has-datum-step') === 'true';

    const shoeSize = document.getElementById('config-shoe-size');
    if (shoeSize && config.shoeSize) shoeSize.value = config.shoeSize;

    if (config.glitzer && hasGlitzer) {
      const glitzer = document.getElementById('config-glitzer');
      if (glitzer) glitzer.value = config.glitzer;
      const glitzerStep = document.querySelector('.bk-media-configurator-modal__step-content[data-step="2"]');
      if (glitzerStep) {
        const opts = glitzerStep.querySelectorAll('.bk-media-configurator-modal__option');
        opts.forEach(o => {
          o.classList.toggle('selected', o.getAttribute('data-value') === config.glitzer);
        });
      }
    }

    if (has2NamenFelder && config.names) {
      const parts = config.names.split(' & ');
      const n1 = document.getElementById('config-name-1');
      const n2 = document.getElementById('config-name-2');
      if (n1 && parts[0]) n1.value = parts[0].trim();
      if (n2 && parts[1]) n2.value = parts[1].trim();
    } else if (config.names) {
      const names = document.getElementById('config-names');
      if (names) names.value = config.names;
    }

    if (hasDatumStep) {
      if (has3DatumFelder) {
        const d1 = document.getElementById('config-date-1');
        const d2 = document.getElementById('config-date-2');
        const d3 = document.getElementById('config-date-3');
        if (d1 && config.date1) d1.value = config.date1;
        if (d2 && config.date2) d2.value = config.date2;
        if (d3 && config.date3) d3.value = config.date3;
      } else if (config.date) {
        const d = document.getElementById('config-date');
        if (d) d.value = config.date;
      }
    }

    const add = document.getElementById('config-additional');
    if (add && config.additional) add.value = config.additional;

    const wunschbild = document.getElementById('config-wunschbild-url');
    if (wunschbild && config.wunschbild) wunschbild.value = config.wunschbild;

    if (config.schnuersenkelOption1 || config.schnuersenkelOption2) {
      const opt1 = document.getElementById('config-schnuersenkel-option1');
      const opt2 = document.getElementById('config-schnuersenkel-option2');
      if (opt1 && config.schnuersenkelOption1) opt1.value = config.schnuersenkelOption1;
      if (opt2 && config.schnuersenkelOption2) opt2.value = config.schnuersenkelOption2;
      const schnuersenkelImages = document.querySelectorAll('.bk-media-configurator-modal__schnuersenkel-option-image');
      schnuersenkelImages.forEach(img => {
        const val = img.getAttribute('data-value');
        const row = img.closest('.bk-media-configurator-modal__schnuersenkel-option-row');
        const rowIndex = row ? Array.from(row.parentElement.querySelectorAll('.bk-media-configurator-modal__schnuersenkel-option-row')).indexOf(row) : -1;
        const targetVal = rowIndex === 0 ? config.schnuersenkelOption1 : config.schnuersenkelOption2;
        img.classList.toggle('selected', val === targetVal);
      });
      updateSchnuersenkelAddPriceDisplay();
    }

    setupDateInputPlaceholders();
    const loadEl = document.getElementById('config-load-saved');
    if (loadEl) loadEl.style.display = 'none';
    showSuccessMessage('Konfiguration geladen.');
  } catch (e) {
    showErrorMessage('Konfiguration konnte nicht geladen werden.');
  }
}

function checkAndShowLoadSaved() {
  const drawer = document.querySelector('.bk-media-configurator-drawer');
  const productId = drawer?.getAttribute('data-product-id');
  const loadEl = document.getElementById('config-load-saved');
  if (!productId || !loadEl) return;

  try {
    const raw = localStorage.getItem(CONFIG_STORAGE_KEY + productId);
    loadEl.style.display = raw ? 'flex' : 'none';
  } catch (e) {
    loadEl.style.display = 'none';
  }
}

function updateStepDisplay() {
  // Update progress indicators
  const progressSteps = document.querySelectorAll('.bk-media-configurator-modal__step');
  progressSteps.forEach((step) => {
    const stepNumber = parseInt(step.getAttribute('data-step'));
    if (stepNumber <= currentStep) {
      step.classList.add('active');
    } else {
      step.classList.remove('active');
    }
  });
  
  // Show/hide step content
  const stepContents = document.querySelectorAll('.bk-media-configurator-modal__step-content');
  stepContents.forEach((content) => {
    const stepNumber = parseInt(content.getAttribute('data-step'));
    if (stepNumber === currentStep) {
      content.style.display = 'block';
    } else {
      content.style.display = 'none';
    }
  });
  
  // Update navigation buttons
  const prevBtn = document.getElementById('config-prev-btn');
  const nextBtn = document.getElementById('config-next-btn');
  
  if (prevBtn) {
    prevBtn.style.display = currentStep > 1 ? 'block' : 'none';
  }
  
  if (nextBtn) {
    const textSpan = nextBtn.querySelector('.bk-media-configurator-modal__next-btn-text');
    const productPriceSpan = document.getElementById('config-product-price');
    const drawer = document.querySelector('.bk-media-configurator-drawer');
    const productPrice = drawer?.getAttribute('data-product-price') || '';
    if (currentStep === totalSteps) {
      if (textSpan) textSpan.textContent = 'Warenkorb';
      if (productPriceSpan && productPrice) {
        productPriceSpan.textContent = ' ' + productPrice;
        productPriceSpan.style.display = 'inline';
      } else if (productPriceSpan) {
        productPriceSpan.style.display = 'none';
      }
      nextBtn.onclick = addToCartWithConfiguration;
      updateSchnuersenkelAddPriceDisplay();
      const saveBtn = document.getElementById('config-save-btn');
      if (saveBtn) saveBtn.style.display = 'inline-flex';
    } else {
      if (textSpan) textSpan.textContent = 'Weiter';
      nextBtn.onclick = nextStep;
      if (productPriceSpan) productPriceSpan.textContent = '';
      if (productPriceSpan) productPriceSpan.style.display = 'none';
      const saveBtn = document.getElementById('config-save-btn');
      if (saveBtn) saveBtn.style.display = 'none';
    }
  }
}

function updateSchnuersenkelAddPriceDisplay() {
  const wrapperEl = document.getElementById('config-schnuersenkel-add-wrapper');
  const priceEl = document.getElementById('config-schnuersenkel-add-price');
  if (!wrapperEl || !priceEl) return;
  const option1 = document.getElementById('config-schnuersenkel-option1');
  const option2 = document.getElementById('config-schnuersenkel-option2');
  const addSchnuersenkel = option1?.value && option2?.value;
  if (addSchnuersenkel) {
    const drawer = document.querySelector('.bk-media-configurator-drawer');
    const price = drawer?.getAttribute('data-upsell-price') || '';
    if (price) {
      priceEl.textContent = '+ ' + price;
      wrapperEl.style.display = 'flex';
    } else {
      wrapperEl.style.display = 'none';
    }
  } else {
    wrapperEl.style.display = 'none';
  }
}

function handleSchnuersenkelEntfernen() {
  const option1 = document.getElementById('config-schnuersenkel-option1');
  const option2 = document.getElementById('config-schnuersenkel-option2');
  if (option1) option1.value = '';
  if (option2) option2.value = '';
  const schnuersenkelImages = document.querySelectorAll('.bk-media-configurator-modal__schnuersenkel-option-image');
  schnuersenkelImages.forEach(img => img.classList.remove('selected'));
  updateSchnuersenkelAddPriceDisplay();
}

function validateCurrentStep() {
  let isValid = true;
  const drawer = document.querySelector('.bk-media-configurator-drawer');
  const hasGlitzer = drawer ? drawer.getAttribute('data-has-glitzer') === 'true' : false;
  const has3DatumFelder = drawer ? drawer.getAttribute('data-has-3-datum-felder') === 'true' : false;
  const has2NamenFelder = drawer ? drawer.getAttribute('data-has-2-namen-felder') === 'true' : false;
  const hasDatumStep = drawer ? drawer.getAttribute('data-has-datum-step') === 'true' : false;
  
  // Get the current step content element to determine what we're validating
  const currentStepContent = document.querySelector(`.bk-media-configurator-modal__step-content[data-step="${currentStep}"]`);
  if (!currentStepContent) {
    console.error('Current step content not found for step:', currentStep);
    return false;
  }
  
  // Determine step type based on content
  const isShoeSizeStep = currentStepContent.querySelector('#config-shoe-size');
  const isGlitzerStep = currentStepContent.querySelector('#config-glitzer');
  const isNamesStep = currentStepContent.querySelector('#config-names, #config-name-1');
  const isDateStep = currentStepContent.querySelector('#config-date, #config-date-1');
  const isAdditionalStep = currentStepContent.querySelector('#config-additional');
  const isWunschbildStep = currentStepContent.querySelector('#config-wunschbild-input');
  const isSchnuersenkelStep = currentStepContent.querySelector('.bk-media-configurator-modal__schnuersenkel');
  
  if (isShoeSizeStep) {
    const shoeSize = document.getElementById('config-shoe-size');
    if (!shoeSize || !shoeSize.value || shoeSize.value.trim() === '') {
      showFieldError(shoeSize, 'Bitte fülle das Feld aus');
      isValid = false;
    } else {
      clearFieldError(shoeSize);
    }
  } else if (isGlitzerStep) {
    const glitzer = document.getElementById('config-glitzer');
    if (!glitzer || !glitzer.value || glitzer.value.trim() === '') {
      showFieldError(glitzer, 'Bitte fülle das Feld aus');
      isValid = false;
    } else {
      clearFieldError(glitzer);
    }
  } else if (isNamesStep) {
    if (has2NamenFelder) {
      const name1 = document.getElementById('config-name-1');
      const name2 = document.getElementById('config-name-2');
      if (!name1 || !name1.value.trim()) {
        showFieldError(name1, 'Bitte fülle das Feld aus');
        isValid = false;
      } else {
        clearFieldError(name1);
      }
      if (!name2 || !name2.value.trim()) {
        showFieldError(name2, 'Bitte fülle das Feld aus');
        isValid = false;
      } else {
        clearFieldError(name2);
      }
    } else {
      const names = document.getElementById('config-names');
      if (!names || !names.value.trim()) {
        showFieldError(names, 'Bitte fülle das Feld aus');
        isValid = false;
      } else {
        clearFieldError(names);
      }
    }
  } else if (isDateStep) {
    if (has3DatumFelder) {
      const date1 = document.getElementById('config-date-1');
      const date2 = document.getElementById('config-date-2');
      const date3 = document.getElementById('config-date-3');
      
      if (!date1 || !date1.value) {
        showFieldError(date1, 'Bitte fülle das Feld aus');
        isValid = false;
      } else {
        clearFieldError(date1);
      }
      if (!date2 || !date2.value) {
        showFieldError(date2, 'Bitte fülle das Feld aus');
        isValid = false;
      } else {
        clearFieldError(date2);
      }
      if (!date3 || !date3.value) {
        showFieldError(date3, 'Bitte fülle das Feld aus');
        isValid = false;
      } else {
        clearFieldError(date3);
      }
    } else {
      const date = document.getElementById('config-date');
      if (!date || !date.value) {
        showFieldError(date, 'Bitte fülle das Feld aus');
        isValid = false;
      } else {
        clearFieldError(date);
      }
    }
  } else if (isWunschbildStep) {
    isValid = true;
  } else if (isAdditionalStep) {
    const additional = document.getElementById('config-additional');
    if (!additional || !additional.value.trim()) {
      // Additional field is optional, so we don't show error
      clearFieldError(additional);
    } else {
      clearFieldError(additional);
    }
  } else if (isSchnuersenkelStep) {
    const schnuersenkelOption1 = document.getElementById('config-schnuersenkel-option1');
    const schnuersenkelOption2 = document.getElementById('config-schnuersenkel-option2');
    if (schnuersenkelOption1) clearFieldError(schnuersenkelOption1);
    if (schnuersenkelOption2) clearFieldError(schnuersenkelOption2);
  }
  
  return isValid;
}

function showFieldError(field, message) {
  if (!field) return;
  
  field.classList.add('error');
  
  // Remove existing error message
  const existingError = field.parentNode.querySelector('.field-error');
  if (existingError) {
    existingError.remove();
  }
  
  // Add new error message
  const errorDiv = document.createElement('div');
  errorDiv.className = 'field-error';
  errorDiv.textContent = message;
  field.parentNode.appendChild(errorDiv);
}

function clearFieldError(field) {
  if (!field) return;
  
  field.classList.remove('error');
  
  const existingError = field.parentNode.querySelector('.field-error');
  if (existingError) {
    existingError.remove();
  }
}

function nextStep() {
  if (validateCurrentStep()) {
    currentStep++;
    updateStepDisplay();
  }
}

function previousStep() {
  if (currentStep > 1) {
    currentStep--;
    updateStepDisplay();
  }
}

async function addToCartWithConfiguration() {
  if (!validateCurrentStep()) {
    return;
  }
  
  const nextBtn = document.getElementById('config-next-btn');
  if (nextBtn) {
    nextBtn.setAttribute('aria-busy', 'true');
    nextBtn.textContent = 'Gute Wahl!';
  }
  
  try {
    // Check if glitzer is enabled
    const drawer = document.querySelector('.bk-media-configurator-drawer');
    const hasGlitzer = drawer ? drawer.getAttribute('data-has-glitzer') === 'true' : false;
    const has3DatumFelder = drawer ? drawer.getAttribute('data-has-3-datum-felder') === 'true' : false;
    const has2NamenFelder = drawer ? drawer.getAttribute('data-has-2-namen-felder') === 'true' : false;
    const hasDatumStep = drawer ? drawer.getAttribute('data-has-datum-step') === 'true' : false;
    
    // Get configuration data
    const shoeSizeElement = document.getElementById('config-shoe-size');
    const additionalElement = document.getElementById('config-additional');
    
    let names = '';
    if (has2NamenFelder) {
      const name1Element = document.getElementById('config-name-1');
      const name2Element = document.getElementById('config-name-2');
      names = `${name1Element ? name1Element.value : ''} & ${name2Element ? name2Element.value : ''}`;
    } else {
      const namesElement = document.getElementById('config-names');
      names = namesElement ? namesElement.value : '';
    }
    
    const config = {
      shoeSize: shoeSizeElement ? shoeSizeElement.value : '',
      names: names,
      additional: additionalElement ? additionalElement.value : ''
    };
    
    if (hasGlitzer) {
      const glitzerElement = document.getElementById('config-glitzer');
      config.glitzer = glitzerElement ? glitzerElement.value : '';
    }
    
    // Only add date data if the date step is enabled
    if (hasDatumStep) {
      if (has3DatumFelder) {
        const date1 = document.getElementById('config-date-1');
        const date2 = document.getElementById('config-date-2');
        const date3 = document.getElementById('config-date-3');
        if (date1) config.date1 = date1.value;
        if (date2) config.date2 = date2.value;
        if (date3) config.date3 = date3.value;
      } else {
        const date = document.getElementById('config-date');
        if (date) config.date = date.value;
      }
    }
    
    const schnuersenkelOption1 = document.getElementById('config-schnuersenkel-option1');
    const schnuersenkelOption2 = document.getElementById('config-schnuersenkel-option2');
    if (schnuersenkelOption1 && schnuersenkelOption1.value) {
      config.schnuersenkelOption1 = schnuersenkelOption1.value;
    }
    if (schnuersenkelOption2 && schnuersenkelOption2.value) {
      config.schnuersenkelOption2 = schnuersenkelOption2.value;
    }
    config.schnuersenkelAdd = !!(schnuersenkelOption1?.value && schnuersenkelOption2?.value);
    
    // Find the product form
    const productForm = document.querySelector('form[is="product-form"]');
    if (!productForm) {
      throw new Error('Product form not found');
    }
    
    const formData = new FormData(productForm);
    formData.delete('properties[Schnürsenkel Bild]');
    
    formData.set('properties[Schuhgröße]', config.shoeSize);
    
    if (hasGlitzer && config.glitzer) {
      formData.set('properties[Glitzer]', config.glitzer);
    }
    
    formData.set('properties[Namen]', config.names);
    
    // Only add date properties if the date step is enabled
    if (hasDatumStep) {
      if (has3DatumFelder) {
        formData.set('properties[Datum 1]', formatDate(config.date1));
        formData.set('properties[Datum 2]', formatDate(config.date2));
        formData.set('properties[Datum 3]', formatDate(config.date3));
      } else {
        formData.set('properties[Datum]', formatDate(config.date));
      }
    }
    
    if (config.additional.trim()) {
      formData.set('properties[Zusätze]', config.additional);
    }
    
    const wunschbildUrlInput = document.getElementById('config-wunschbild-url');
    if (wunschbildUrlInput && wunschbildUrlInput.value) {
      formData.set('properties[Wunschbild]', wunschbildUrlInput.value);
    }
    
    // Don't add Schnürsenkel options to main product - they'll be added to the Schnürsenkel product instead
    
    // Prepare sections to bundle (like the theme does)
    let sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { 
      bubbles: true, 
      detail: { sections: sectionsToBundle } 
    }));
    
    // Add sections to form data
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', `${window.Shopify?.routes?.root || ''}variants/${formData.get('id')}`);
    
    // Add main product to cart
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    
    const responseJson = await response.json();
    
    if (response.ok) {
      // If Schnürsenkel checkbox is checked, add the upsell product to cart as well
      let upsellResponseJson = null;
      if (config.schnuersenkelAdd === true) {
        // Get the upsell product from the configurator
        const drawer = document.querySelector('.bk-media-configurator-drawer');
        const upsellProduct = drawer ? drawer.getAttribute('data-upsell-product') : null;
        const upsellVariant = drawer ? drawer.getAttribute('data-upsell-variant') : null;
        
        if (upsellProduct && upsellVariant) {
          const upsellFormData = new FormData();
          upsellFormData.set('id', upsellVariant);
          upsellFormData.set('quantity', '1');
          upsellFormData.set('properties[Upsell]', 'Ja');
          
          if (config.schnuersenkelOption1) {
            upsellFormData.set('properties[Farbe]', config.schnuersenkelOption1);
          }
          if (config.schnuersenkelOption2) {
            upsellFormData.set('properties[Spitze]', config.schnuersenkelOption2);
          }
          
          upsellFormData.set('sections', sectionsToBundle.join(','));
          upsellFormData.set('sections_url', `${window.Shopify?.routes?.root || ''}variants/${upsellVariant}`);
          
          const upsellResponse = await fetch('/cart/add.js', {
            method: 'POST',
            body: upsellFormData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          upsellResponseJson = await upsellResponse.json();
        }
      }
      
      // Get updated cart data
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || ''}cart.js`);
      const cartData = await cartResponse.json();
      
      // Merge the sections from the add response with cart data
      cartData.sections = responseJson.sections;
      
      // If upsell was added, merge its sections too
      if (upsellResponseJson && upsellResponseJson.sections) {
        cartData.sections = { ...cartData.sections, ...upsellResponseJson.sections };
      }
      
      // Prepare items array
      const items = [];
      if (responseJson.hasOwnProperty('items')) {
        items.push(...responseJson.items);
      } else {
        items.push(responseJson);
      }
      
      // Add upsell item if it was added
      if (upsellResponseJson) {
        if (upsellResponseJson.hasOwnProperty('items')) {
          items.push(...upsellResponseJson.items);
        } else {
          items.push(upsellResponseJson);
        }
      }
      
      
      // Dispatch the variant:add event (like the theme does)
      const productForm = document.querySelector('form[is="product-form"]');
      if (productForm) {
        productForm.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: items,
            cart: cartData
          }
        }));
      }
      
      // Dispatch the cart:change event
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartData
        }
      }));
      
      // Close configurator drawer after successful cart addition
      closeProductConfigurator();
      
      // Show success message
      showSuccessMessage('Produkt erfolgreich hinzugefügt.');
      
      // Open cart drawer if cart type is drawer
      if (window.themeVariables?.settings?.cartType === 'drawer') {
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
        }
      }
      
    } else {
      throw new Error(responseJson.message || responseJson.description || 'Fehler beim Hinzufügen zum Warenkorb');
    }
    
  } catch (error) {
    console.error('Error adding to cart:', error);
    showErrorMessage('Fehler beim Hinzufügen zum Warenkorb: ' + error.message);
  } finally {
    if (nextBtn) {
      nextBtn.removeAttribute('aria-busy');
      updateStepDisplay();
    }
  }
}

function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}

function initVideoPopup() {
  const triggerBtn = document.querySelector('.bk-media-video-trigger-btn');
  const popup = document.getElementById('bk-media-video-popup');
  const video = document.getElementById('bk-media-popup-video');
  const closeBtn = popup?.querySelector('.bk-media-video-popup__close');
  const overlay = popup?.querySelector('.bk-media-video-popup__overlay');
  
  if (!triggerBtn || !popup || !video) return;
  
  triggerBtn.addEventListener('click', function() {
    popup.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    video.play();
  });
  
  const closePopup = function() {
    popup.setAttribute('hidden', '');
    document.body.style.overflow = '';
    video.pause();
    video.currentTime = 0;
  };
  
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }
  
  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !popup.hasAttribute('hidden')) {
      closePopup();
    }
  });
}

function showConfiguratorSaveConfirmation() {
  const configuratorDrawer = document.querySelector('.bk-media-configurator-drawer');
  const savedDrawer = document.getElementById('saved-configs-drawer');
  const savedBanner = document.getElementById('saved-configs-drawer-saved-banner');

  if (configuratorDrawer && typeof configuratorDrawer.hide === 'function') {
    configuratorDrawer.hide();
  }

  renderSavedConfigsDrawer();
  if (savedBanner) {
    savedBanner.style.display = 'block';
    setTimeout(() => {
      savedBanner.style.display = 'none';
    }, 5000);
  }
  if (savedDrawer && typeof savedDrawer.show === 'function') {
    savedDrawer.show();
    try { sessionStorage.setItem('bk-saved-configs-just-saved', '1'); } catch (e) {}
  }
}

function onSavedConfigsDrawerClosed() {
  try {
    if (sessionStorage.getItem('bk-saved-configs-just-saved') !== '1') return;
    sessionStorage.removeItem('bk-saved-configs-just-saved');
  } catch (e) { return; }
  const scrollDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1200;
  const start = window.pageYOffset;
  const startTime = performance.now();
  function smoothScroll() {
    const elapsed = performance.now() - startTime;
    const progress = scrollDuration === 0 ? 1 : Math.min(elapsed / scrollDuration, 1);
    const easeProgress = 1 - Math.pow(1 - progress, 2);
    window.scrollTo(0, start * (1 - easeProgress));
    if (progress < 1) requestAnimationFrame(smoothScroll);
    else {
      const triggerDesktop = document.getElementById('bk-saved-configs-header-trigger-desktop');
      const triggerMobile = document.getElementById('bk-saved-configs-header-trigger-mobile');
      [triggerDesktop, triggerMobile].forEach(trigger => {
        if (trigger) {
          trigger.classList.add('bk-saved-configs-header-trigger--highlight');
          setTimeout(() => trigger.classList.remove('bk-saved-configs-header-trigger--highlight'), 4000);
        }
      });
    }
  }
  requestAnimationFrame(smoothScroll);
}

function updateSavedConfigsHeaderCount() {
  let count = 0;
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(CONFIG_STORAGE_KEY)) count++;
    }
  } catch (e) {}
  const countEl = document.getElementById('bk-saved-configs-header-count');
  const countElMobile = document.getElementById('bk-saved-configs-header-count-mobile');
  [countEl, countElMobile].forEach(el => {
    if (el) {
      el.textContent = String(count);
      el.classList.toggle('opacity-0', count === 0);
    }
  });
  const triggerMobile = document.getElementById('bk-saved-configs-header-trigger-mobile');
  const triggerDesktop = document.getElementById('bk-saved-configs-header-trigger-desktop');
  [triggerMobile, triggerDesktop].forEach(el => {
    if (el) el.style.display = count > 0 ? '' : 'none';
  });
}

function formatDateForDisplay(dateString) {
  if (!dateString) return '';
  const d = new Date(dateString);
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

function buildConfigLineItemHtml(key, data) {
  const { productTitle, productUrl, productImage, config } = data;
  const url = productUrl ? (productUrl.startsWith('/') ? productUrl : '/' + productUrl) : '#';
  const imgHtml = productImage ? `<div class="line-item__media-wrapper"><a href="${url}"><img src="${productImage.replace(/"/g, '&quot;')}" alt="" class="line-item__media rounded-xs" width="96" height="96" loading="lazy"></a></div>` : '';
  const parts = [];
  if (config.shoeSize) parts.push(`Schuhgröße: ${config.shoeSize}`);
  if (config.glitzer) parts.push(`Glitzer: ${config.glitzer}`);
  if (config.names) parts.push(`Namen: ${config.names}`);
  if (config.date) parts.push(`Datum: ${formatDateForDisplay(config.date)}`);
  if (config.date1) parts.push(`Datum 1: ${formatDateForDisplay(config.date1)}`);
  if (config.date2) parts.push(`Datum 2: ${formatDateForDisplay(config.date2)}`);
  if (config.date3) parts.push(`Datum 3: ${formatDateForDisplay(config.date3)}`);
  if (config.additional) parts.push(`Anmerkungen: ${config.additional}`);
  if (config.schnuersenkelAdd && config.schnuersenkelOption1 && config.schnuersenkelOption2) {
    parts.push(`Schnürsenkel: ${config.schnuersenkelOption1} / ${config.schnuersenkelOption2}`);
  }
  if (config.wunschbild) parts.push('Wunschbild: ✓');
  const propsHtml = parts.length > 0 ? `<ul class="list-disc text-sm text-subdued"><li>${parts.join('</li><li>')}</li></ul>` : '';
  return `
    <div class="saved-config-item line-item ${imgHtml ? '' : 'saved-config-item--no-image'}" data-config-key="${key.replace(/"/g, '&quot;')}">
      <a href="${url}" class="saved-config-item__title bold"><span class="reversed-link hover:show h6">${(productTitle || 'Produkt').replace(/</g, '&lt;')}</span></a>
      ${imgHtml}
      <div class="line-item__info">
        ${propsHtml}
      </div>
      <div class="bk-saved-config-item__actions">
        <button type="button" class="button button--primary button--sm" data-add-config="${key.replace(/"/g, '&quot;')}">In den Warenkorb</button>
        <button type="button" class="bk-saved-config-item__remove bk-media-remove-icon" data-remove-config="${key.replace(/"/g, '&quot;')}" aria-label="Entfernen">
          <img src="https://cdn.shopify.com/s/files/1/0536/0254/9956/files/icons8-leerer-papierkorb-100.png?v=1760696320" alt="Entfernen" width="16" height="16" style="pointer-events: none;">
        </button>
      </div>
    </div>
  `;
}

function renderSavedConfigsDrawer() {
  const listEl = document.getElementById('saved-configs-drawer-list');
  const emptyEl = document.getElementById('saved-configs-drawer-empty');
  if (!listEl) return;

  const items = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(CONFIG_STORAGE_KEY)) {
        const raw = localStorage.getItem(key);
        if (raw) {
          const data = JSON.parse(raw);
          items.push({ key, ...data });
        }
      }
    }
    items.sort((a, b) => {
      const aTime = a.savedAt ? new Date(a.savedAt).getTime() : 0;
      const bTime = b.savedAt ? new Date(b.savedAt).getTime() : 0;
      return bTime - aTime;
    });
  } catch (e) {}

  emptyEl.style.display = items.length === 0 ? 'block' : 'none';
  listEl.style.display = items.length === 0 ? 'none' : 'flex';
  listEl.innerHTML = items.map(({ key, ...data }) => buildConfigLineItemHtml(key, data)).join('');
}

document.addEventListener('dialog:after-hide', function(event) {
  if (event.target && event.target.id === 'saved-configs-drawer') {
    onSavedConfigsDrawerClosed();
  }
});

function initSavedConfigsDrawer() {
  const triggers = document.querySelectorAll('[aria-controls="saved-configs-drawer"]');
  const drawer = document.getElementById('saved-configs-drawer');
  if (!triggers.length || !drawer) return;

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      renderSavedConfigsDrawer();
      if (drawer && typeof drawer.show === 'function') drawer.show();
    });
  });

  document.addEventListener('click', function(e) {
    const infoBtn = e.target.closest('#saved-configs-drawer-info-btn');
    if (infoBtn) {
      e.preventDefault();
      e.stopPropagation();
      const popup = document.getElementById('saved-configs-drawer-info-popup');
      if (popup) {
        popup.hidden = !popup.hidden;
        infoBtn.setAttribute('aria-expanded', popup.hidden ? 'false' : 'true');
      }
      return;
    }
    const popup = document.getElementById('saved-configs-drawer-info-popup');
    if (popup && !popup.hidden && !e.target.closest('.saved-configs-drawer__info-wrap')) {
      popup.hidden = true;
      const infoBtn = document.getElementById('saved-configs-drawer-info-btn');
      if (infoBtn) infoBtn.setAttribute('aria-expanded', 'false');
    }
    const addBtn = e.target.closest('[data-add-config]');
    if (addBtn) {
      e.preventDefault();
      const key = addBtn.getAttribute('data-add-config');
      addSavedConfigToCart(key);
    }
    const removeBtn = e.target.closest('[data-remove-config]');
    if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.getAttribute('data-remove-config');
      try {
        localStorage.removeItem(key);
        renderSavedConfigsDrawer();
        updateSavedConfigsHeaderCount();
      } catch (err) {}
    }
  });
}

async function addSavedConfigToCart(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return;
    const data = JSON.parse(raw);
    const { variantId, upsellVariantId, config } = data;

    const formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    formData.set('properties[Schuhgröße]', config.shoeSize || '');
    if (config.glitzer) formData.set('properties[Glitzer]', config.glitzer);
    formData.set('properties[Namen]', config.names || '');
    if (config.date1 !== undefined) formData.set('properties[Datum 1]', formatDate(config.date1));
    if (config.date2 !== undefined) formData.set('properties[Datum 2]', formatDate(config.date2));
    if (config.date3 !== undefined) formData.set('properties[Datum 3]', formatDate(config.date3));
    if (config.date !== undefined && config.date1 === undefined) formData.set('properties[Datum]', formatDate(config.date));
    if (config.additional) formData.set('properties[Zusätze]', config.additional);
    if (config.wunschbild) formData.set('properties[Wunschbild]', config.wunschbild);

    let sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
    const cartDrawer = document.getElementById('cart-drawer');
    const sectionId = cartDrawer?.getAttribute('data-section-id') || 'cart-drawer';
    if (!sectionsToBundle.includes(sectionId)) sectionsToBundle.push(sectionId);
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', `${window.Shopify?.routes?.root || ''}variants/${variantId}`);

    const response = await fetch(`${window.Shopify?.routes?.root || ''}cart/add.js`, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    const responseJson = await response.json();
    if (!response.ok) throw new Error(responseJson.message || responseJson.description || 'Fehler');

    let items = responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson];

    if (config.schnuersenkelAdd && config.schnuersenkelOption1 && config.schnuersenkelOption2 && upsellVariantId) {
      const upsellFormData = new FormData();
      upsellFormData.set('id', upsellVariantId);
      upsellFormData.set('quantity', '1');
      upsellFormData.set('properties[Upsell]', 'Ja');
      upsellFormData.set('properties[Farbe]', config.schnuersenkelOption1);
      upsellFormData.set('properties[Spitze]', config.schnuersenkelOption2);
      upsellFormData.set('sections', sectionsToBundle.join(','));
      upsellFormData.set('sections_url', `${window.Shopify?.routes?.root || ''}variants/${upsellVariantId}`);
      const upsellResponse = await fetch(`${window.Shopify?.routes?.root || ''}cart/add.js`, {
        method: 'POST',
        body: upsellFormData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const upsellJson = await upsellResponse.json();
      if (upsellResponse.ok && upsellJson) {
        items = items.concat(upsellJson.hasOwnProperty('items') ? upsellJson.items : [upsellJson]);
      }
    }

    const cartResponse = await fetch(`${window.Shopify?.routes?.root || ''}cart.js`);
    const cartData = await cartResponse.json();
    cartData.sections = responseJson.sections || {};
    if (responseJson.sections) Object.assign(cartData.sections, responseJson.sections);

    const productForm = document.querySelector('form[is="product-form"]') || document.createElement('form');
    if (!document.querySelector('form[is="product-form"]')) document.body.appendChild(productForm);
    productForm.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items, cart: cartData } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartData } }));

    showSuccessMessage('Produkt erfolgreich hinzugefügt.');
    if (window.themeVariables?.settings?.cartType === 'drawer') {
      const cartDrawerEl = document.getElementById('cart-drawer');
      if (cartDrawerEl && typeof cartDrawerEl.show === 'function') cartDrawerEl.show();
    }

    const savedDrawer = document.getElementById('saved-configs-drawer');
    if (savedDrawer && typeof savedDrawer.hide === 'function') savedDrawer.hide();
  } catch (err) {
    console.error('Add saved config to cart:', err);
    showErrorMessage(err.message || 'Fehler beim Hinzufügen zum Warenkorb.');
  }
}

function showConfiguratorSaveError() {
  const saveBtn = document.getElementById('config-save-btn');
  const confirmation = document.getElementById('config-save-confirmation');
  if (saveBtn && confirmation) {
    saveBtn.style.display = 'none';
    confirmation.textContent = 'Konfiguration konnte nicht gespeichert werden.';
    confirmation.classList.add('bk-media-configurator-modal__save-confirmation--error');
    confirmation.style.display = 'flex';
    setTimeout(() => {
      confirmation.style.display = 'none';
      confirmation.textContent = 'Konfiguration gespeichert.';
      confirmation.classList.remove('bk-media-configurator-modal__save-confirmation--error');
      saveBtn.style.display = 'inline-flex';
    }, 4000);
  }
}

function showSuccessMessage(message) {
  // Create success notification
  const notification = document.createElement('div');
  notification.className = 'bk-media-notification bk-media-notification--success';
  notification.textContent = message;
  
  document.body.appendChild(notification);
  
  // Remove after 3 seconds
  setTimeout(() => {
    notification.remove();
  }, 3000);
}

function showErrorMessage(message) {
  // Create error notification
  const notification = document.createElement('div');
  notification.className = 'bk-media-notification bk-media-notification--error';
  notification.textContent = message;
  
  document.body.appendChild(notification);
  
  // Remove after 5 seconds
  setTimeout(() => {
    notification.remove();
  }, 5000);
}

function initGalleryCollapse() {
  const expandBars = document.querySelectorAll('.bk-media-gallery-expand-bar');
  
  expandBars.forEach(expandBar => {
    const button = expandBar.querySelector('.bk-media-gallery-expand-btn');
    const galleryId = expandBar.getAttribute('data-gallery-id');
    const gallery = document.getElementById(galleryId);
    
    if (!button || !gallery) return;
    
    // Skip initialization on mobile - let theme handle horizontal scrolling
    if (window.innerWidth <= 699) {
      // Ensure all images are visible on mobile
      gallery.classList.remove('bk-media-gallery-collapsed');
      const hiddenImages = gallery.querySelectorAll('.bk-media-gallery-hidden');
      hiddenImages.forEach(img => img.style.display = 'block');
      return;
    }
    
    // Remove any existing event listeners
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    // Add single event listener that handles both states
    newButton.addEventListener('click', function() {
      const textSpan = newButton.querySelector('.bk-media-gallery-expand-text');
      const countSpan = newButton.querySelector('.bk-media-gallery-expand-count');
      const isCollapsed = gallery.classList.contains('bk-media-gallery-collapsed');
      
      if (isCollapsed) {
        // Currently collapsed, expand it
        gallery.classList.remove('bk-media-gallery-collapsed');
        if (textSpan) {
          textSpan.textContent = 'Weniger Bilder anzeigen';
        }
        if (countSpan) {
          countSpan.textContent = countSpan.textContent.replace('+', '-');
        }
      } else {
        // Currently expanded, collapse it
        gallery.classList.add('bk-media-gallery-collapsed');
        if (textSpan) {
          textSpan.textContent = 'Mehr Bilder anzeigen';
        }
        if (countSpan) {
          countSpan.textContent = countSpan.textContent.replace('-', '+');
        }
      }
    });
  });
  
  // Handle window resize to maintain mobile behavior
  window.addEventListener('resize', function() {
    const isMobile = window.innerWidth <= 699;
    const galleries = document.querySelectorAll('[id*="product-gallery-"]');
    
    galleries.forEach(gallery => {
      const hiddenImages = gallery.querySelectorAll('.bk-media-gallery-hidden');
      
      if (isMobile) {
        // Mobile: remove collapsed state and show all images
        gallery.classList.remove('bk-media-gallery-collapsed');
        hiddenImages.forEach(img => img.style.display = 'block');
      } else {
        // Desktop: restore collapsed state if it should be collapsed
        const totalImages = gallery.querySelectorAll('.product-gallery__media').length;
        if (totalImages > 4) {
          gallery.classList.add('bk-media-gallery-collapsed');
          hiddenImages.forEach(img => img.style.display = 'none');
        }
      }
    });
  });
}

function initFaqAccordions() {
  const accordions = document.querySelectorAll('.bk-media-faq-accordion');
  
  accordions.forEach(accordion => {
    const button = accordion.querySelector('.bk-media-faq-accordion-btn');
    const answer = accordion.querySelector('.bk-media-faq-answer');
    
    if (!button || !answer) return;
    
    button.addEventListener('click', function() {
      const isActive = accordion.classList.contains('active');
      
      if (isActive) {
        accordion.classList.remove('active');
        answer.setAttribute('hidden', '');
      } else {
        accordion.classList.add('active');
        answer.removeAttribute('hidden');
      }
    });
  });
}

// Re-initialize on section load (for dynamic content)
document.addEventListener('shopify:section:load', function() {
  initCollapsibleDescriptions();
  initAudioPlayers();
  initProductConfigurator();
  initVideoPopup();
  initGalleryCollapse();
  initFaqAccordions();
});

document.addEventListener('DOMContentLoaded', function() {
  initTimelineScroll();
});

function initTimelineScroll() {
  // Timeline scroll functionality is now handled by native browser scrolling
  // No additional JavaScript needed for free vertical scrolling
}

// Reinitialize on section load (for theme editor)
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.bk-media-timeline-scrollable')) {
    initTimelineScroll();
  }
  if (event.target.querySelector('.bk-media-text-switcher')) {
    initTextSwitcher();
  }
  
  if (event.target.querySelector('.bk-media-brand-switcher')) {
    initBrandSwitcher();
  }
});

// ========================================
// TEXT SWITCHER FUNCTIONALITY
// ========================================

function initTextSwitcher() {
  const switchers = document.querySelectorAll('.bk-media-text-switcher');
  
  switchers.forEach(switcher => {
    const viewButtons = switcher.querySelectorAll('.bk-media-text-switcher__button[data-view]');
    const brandButtons = switcher.querySelectorAll('.bk-media-text-switcher__button[data-brand]');
    const productList = document.querySelector('.product-list[data-image-view]');
    
    if (!viewButtons.length || !productList) return;
    
    // Handle view switcher (Ansicht)
    viewButtons.forEach(button => {
      button.addEventListener('click', function() {
        const view = this.dataset.view;
        
        // Update only view button states
        viewButtons.forEach(btn => {
          btn.classList.remove('active');
          btn.setAttribute('aria-pressed', 'false');
        });
        
        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');
        
        // Update product list data attribute
        productList.setAttribute('data-image-view', view);
        
        // Toggle product images
        toggleProductImages(view);
        
        // Apply combined filters
        applyCombinedFilters();
      });
    });
    
    // Handle brand switcher (Marke)
    brandButtons.forEach(button => {
      button.addEventListener('click', function() {
        const brand = this.dataset.brand;
        
        // Update only brand button states
        brandButtons.forEach(btn => {
          btn.classList.remove('active');
          btn.setAttribute('aria-pressed', 'false');
        });
        
        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');
        
        // Apply combined filters
        applyCombinedFilters();
      });
    });
  });
}

function toggleProductImages(view) {
  const productCards = document.querySelectorAll('.product-card');
  
  productCards.forEach(card => {
    const secondaryImage = card.querySelector('.product-card__image--secondary');
    
    if (view === 'secondary') {
      // Check if this card has a custom secondary image that needs to be updated
      const customImageUrl = card.dataset.customSecondaryImage;
      
      // Only update src if custom image exists and differs from current src
      if (customImageUrl && secondaryImage) {
        const currentSrc = secondaryImage.src || secondaryImage.getAttribute('src');
        // Only update if the src doesn't already match (handles cases where product has both media and custom image)
        if (!currentSrc || !currentSrc.includes(customImageUrl.split('?')[0])) {
          // Build srcset for responsive images
          const srcset = customImageUrl.replace('width=1800', 'width=200') + ' 200w, ' +
                        customImageUrl.replace('width=1800', 'width=300') + ' 300w, ' +
                        customImageUrl.replace('width=1800', 'width=400') + ' 400w, ' +
                        customImageUrl.replace('width=1800', 'width=500') + ' 500w, ' +
                        customImageUrl.replace('width=1800', 'width=600') + ' 600w, ' +
                        customImageUrl.replace('width=1800', 'width=700') + ' 700w, ' +
                        customImageUrl.replace('width=1800', 'width=800') + ' 800w, ' +
                        customImageUrl.replace('width=1800', 'width=1000') + ' 1000w, ' +
                        customImageUrl.replace('width=1800', 'width=1200') + ' 1200w, ' +
                        customImageUrl.replace('width=1800', 'width=1400') + ' 1400w, ' +
                        customImageUrl.replace('width=1800', 'width=1600') + ' 1600w, ' +
                        customImageUrl + ' 1800w';
          
          secondaryImage.setAttribute('srcset', srcset);
          secondaryImage.setAttribute('src', customImageUrl);
        }
      }
      
      card.classList.add('product-card--show-secondary-media');
      card.classList.add('bk-media-show-models');
    } else {
      card.classList.remove('product-card--show-secondary-media');
      card.classList.remove('bk-media-show-models');
    }
  });
}

// ========================================
// BRAND SWITCHER FUNCTIONALITY
// ========================================

function initBrandSwitcher() {
  // Brand switcher is now handled in initTextSwitcher
  // This function is kept for compatibility but functionality is moved
}

function applyCombinedFilters() {
  const productWrappers = document.querySelectorAll('.product-card-wrapper');
  const activeBrandButton = document.querySelector('.bk-media-text-switcher__button[data-brand].active');
  const activeViewButton = document.querySelector('.bk-media-text-switcher__button[data-view].active');
  
  const selectedBrand = activeBrandButton ? activeBrandButton.dataset.brand : 'all';
  const selectedView = activeViewButton ? activeViewButton.dataset.view : 'primary';
  
  productWrappers.forEach(wrapper => {
    const productBrand = wrapper.dataset.productBrand;
    const productCard = wrapper.querySelector('.product-card');
    
    // Check brand filter
    let brandMatch = true;
    if (selectedBrand !== 'all') {
      brandMatch = productBrand && productBrand.includes(selectedBrand.toLowerCase());
    }
    
    // Check view filter (image type)
    let viewMatch = true;
    if (selectedView === 'secondary') {
      // For secondary view, check if product has secondary image
      const hasSecondaryImage = productCard && productCard.querySelector('.product-card__image--secondary');
      viewMatch = hasSecondaryImage;
    }
    
    // Show/hide based on both filters
    if (brandMatch && viewMatch) {
      wrapper.style.display = 'block';
    } else {
      wrapper.style.display = 'none';
    }
  });
}

function filterProductsByBrand(brand) {
  const productWrappers = document.querySelectorAll('.product-card-wrapper');
  
  productWrappers.forEach(wrapper => {
    const productBrand = wrapper.dataset.productBrand;
    
    if (brand === 'all') {
      wrapper.style.display = 'block';
    } else {
      // Check if the product brand matches the selected brand
      if (productBrand && productBrand.includes(brand.toLowerCase())) {
        wrapper.style.display = 'block';
      } else {
        wrapper.style.display = 'none';
      }
    }
  });
}


// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  initTextSwitcher();
  initBrandSwitcher();
});

/* ========================================
   INLINE PRODUCT CONFIGURATOR FUNCTIONALITY
   ======================================== */

function initInlineProductConfigurator() {
  console.log('BK-Media: Initializing inline product configurator...');
  
  const configurators = document.querySelectorAll('.bk-media-product-configurator');
  
  configurators.forEach(configurator => {
    const blockId = configurator.getAttribute('data-block-id');
    const inputs = configurator.querySelectorAll('.bk-media-configurator-input');
    
    // Add change event listeners to all radio inputs
    inputs.forEach(input => {
      input.addEventListener('change', function() {
        console.log('BK-Media: Configurator option changed:', this.name, this.value);
        updateConfiguratorDisplay(configurator);
      });
    });
    
    // Initialize display
    updateConfiguratorDisplay(configurator);
  });
}

function updateConfiguratorDisplay(configurator) {
  const blockId = configurator.getAttribute('data-block-id');
  const inputs = configurator.querySelectorAll('.bk-media-configurator-input:checked');
  
  console.log('BK-Media: Updating configurator display for block:', blockId);
  console.log('BK-Media: Selected options:', Array.from(inputs).map(input => `${input.name}: ${input.value}`));
  
  // Update visual state of choices
  const choices = configurator.querySelectorAll('.bk-media-configurator-choice');
  choices.forEach(choice => {
    const input = choice.querySelector('.bk-media-configurator-input');
    if (input.checked) {
      choice.classList.add('selected');
    } else {
      choice.classList.remove('selected');
    }
  });
}

// Re-initialize when sections are loaded (for dynamic content)
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.bk-media-product-configurator')) {
    initInlineProductConfigurator();
  }
});

/* ========================================
   ANNOUNCEMENT BAR SCROLLING ENHANCEMENT
   ======================================== */

function enhanceAnnouncementBarScrolling() {
  const marqueeElements = document.querySelectorAll('marquee-text');
  
  marqueeElements.forEach(marquee => {
    let retryCount = 0;
    const maxRetries = 20;
    
    function calculateDuration() {
      const scrollingSpeed = parseInt(marquee.getAttribute('scrolling-speed') || 5);
      const containerWidth = marquee.clientWidth || marquee.offsetWidth;
      const firstItem = marquee.querySelector('span, .announcement-bar__item');
      
      if (!firstItem || !containerWidth || containerWidth === 0) {
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(calculateDuration, 100);
        }
        return;
      }
      
      const contentWidth = firstItem.scrollWidth || firstItem.offsetWidth;
      
      if (!contentWidth || contentWidth === 0) {
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(calculateDuration, 100);
        }
        return;
      }
      
      retryCount = 0;
      
      const slowFactor = 1 + (Math.min(1600, containerWidth) - 375) / (1600 - 375);
      const duration = (scrollingSpeed * slowFactor * contentWidth / containerWidth).toFixed(3);
      
      const finalDuration = Math.max(parseFloat(duration), 5);
      
      const currentDuration = marquee.style.getPropertyValue('--marquee-animation-duration');
      const currentDurationValue = currentDuration ? parseFloat(currentDuration) : 0;
      
      if (!currentDuration || currentDurationValue === 0 || currentDurationValue < 1) {
        marquee.style.setProperty('--marquee-animation-duration', `${finalDuration}s`);
        
        void marquee.offsetWidth;
      }
    }
    
    function initCalculation() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          requestAnimationFrame(() => {
            setTimeout(calculateDuration, 0);
          });
        });
      } else {
        requestAnimationFrame(() => {
          setTimeout(calculateDuration, 0);
        });
      }
    }
    
    initCalculation();
    
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        retryCount = 0;
        calculateDuration();
      }, 150);
    };
    
    window.addEventListener('resize', handleResize);
    
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            retryCount = 0;
            setTimeout(calculateDuration, 50);
          }
        });
      }, { threshold: 0.1 });
      
      observer.observe(marquee);
    }
    
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        retryCount = 0;
        setTimeout(calculateDuration, 100);
      });
    }
    
    window.addEventListener('load', () => {
      retryCount = 0;
      setTimeout(calculateDuration, 100);
    });
  });
}

document.addEventListener('DOMContentLoaded', enhanceAnnouncementBarScrolling);

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('marquee-text')) {
    setTimeout(enhanceAnnouncementBarScrolling, 100);
  }
});

/* ========================================
   IMAGE LINK BLOCKS LIGHTBOX
   ======================================== */

function initImageLinkBlocksLightbox() {
  const imageLinkBlocks = document.querySelectorAll('image-link-blocks[data-bk-media-lightbox="true"]');
  
  imageLinkBlocks.forEach(container => {
    const images = container.querySelectorAll('.bk-media-lightbox-image');
    if (images.length === 0) return;

    let photoswipe = null;

    function initPhotoSwipe() {
      if (photoswipe) return Promise.resolve(photoswipe);

      return import('vendor').then((vendor) => {
        const { PhotoSwipeLightbox } = vendor;
        
        photoswipe = new PhotoSwipeLightbox({
          pswpModule: () => import('photoswipe'),
          bgOpacity: 1,
          maxZoomLevel: 3,
          closeTitle: window.themeVariables?.strings?.closeGallery || 'Close',
          zoomTitle: window.themeVariables?.strings?.zoomGallery || 'Zoom',
          errorMsg: window.themeVariables?.strings?.errorGallery || 'Error loading image',
          arrowPrev: false,
          arrowNext: false,
          counter: false,
          zoom: false,
          closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
            <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
            <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
            <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
          </svg>`
        });

        photoswipe.addFilter('thumbEl', (thumbEl, data) => data['thumbnailElement']);
        photoswipe.on('uiRegister', () => {
          photoswipe.pswp.ui.registerElement({
            name: 'bottom-bar',
            order: 5,
            appendTo: 'wrapper',
            html: `
              <div class="pagination">
                <button class="pagination__item group" rel="prev">
                  <span class="animated-arrow animated-arrow--reverse"></span>
                </button>
                <span class="pagination__current text-sm">
                  <span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span>
                </span>
                <button class="pagination__item group" rel="next">
                  <span class="animated-arrow"></span>
                </button>
              </div>
            `,
            onInit: (el, pswp) => {
              el.querySelector('.pagination__page-count').innerText = pswp.getNumItems();
              el.querySelector('[rel="prev"]')?.addEventListener('click', () => pswp.prev());
              el.querySelector('[rel="next"]')?.addEventListener('click', () => pswp.next());
              pswp.on('change', () => {
                el.querySelector('.pagination__current-page').innerText = pswp.currIndex + 1;
              });
            }
          });
        });

        photoswipe.init();
        return photoswipe;
      }).catch(err => {
        console.error('Failed to load PhotoSwipe:', err);
        return null;
      });
    }

    function openLightbox(index) {
      initPhotoSwipe().then(() => {
        if (photoswipe) {
          const dataSource = Array.from(images).map((image) => {
            return {
              thumbnailElement: image,
              src: image.src,
              srcset: image.srcset,
              msrc: image.currentSrc || image.src,
              width: parseInt(image.getAttribute('width')) || image.naturalWidth,
              height: parseInt(image.getAttribute('height')) || image.naturalHeight,
              alt: image.alt,
              thumbCropped: true
            };
          });
          photoswipe.loadAndOpen(index, dataSource);
        }
      });
    }

    images.forEach((image, index) => {
      image.style.cursor = 'zoom-in';
      const link = image.closest('a');
      
      image.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(index);
      });

      if (link) {
        link.addEventListener('click', (e) => {
          if (e.target === image || image.contains(e.target)) {
            e.preventDefault();
            e.stopPropagation();
            openLightbox(index);
          }
        });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initImageLinkBlocksLightbox);

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('image-link-blocks[data-bk-media-lightbox="true"]')) {
    setTimeout(initImageLinkBlocksLightbox, 100);
  }
});

/* ========================================
   SCHNÜRSENKEL SELECTOR FUNCTIONALITY
   ======================================== */

function initSchnuersenkelSelector() {
  const selectors = document.querySelectorAll('.bk-media-schnuersenkel-selector');
  
  selectors.forEach(selector => {
    const optionButtons = selector.querySelectorAll('.bk-media-schnuersenkel-selector__option-button');
    const option1Input = selector.querySelector('.bk-media-schnuersenkel-selector__option1');
    const option2Input = selector.querySelector('.bk-media-schnuersenkel-selector__option2');
    
    if (!option1Input || !option2Input) return;
    
    const formId = option1Input.getAttribute('form');
    const form = formId ? document.getElementById(formId) : null;
    
    optionButtons.forEach(button => {
      button.addEventListener('click', function() {
        const row = this.closest('.bk-media-schnuersenkel-selector__option-row');
        const isColorRow = row.querySelector('.bk-media-schnuersenkel-selector__option-name')?.textContent.trim() === 'Farbe';
        const isTipRow = row.querySelector('.bk-media-schnuersenkel-selector__option-name')?.textContent.trim() === 'Spitze';
        
        row.querySelectorAll('.bk-media-schnuersenkel-selector__option-button').forEach(btn => {
          btn.classList.remove('selected');
        });
        
        this.classList.add('selected');
        
        const value = this.getAttribute('data-value');
        if (isColorRow && option1Input) {
          option1Input.value = value;
        } else if (isTipRow && option2Input) {
          option2Input.value = value;
        }
        
        if (form) {
          ensureSchnuersenkelProperties(form);
        }
      });
    });
  });
}


function ensureSchnuersenkelProperties(formElement) {
  if (!formElement) return;
  
  const selectors = document.querySelectorAll('.bk-media-schnuersenkel-selector');
  
  selectors.forEach(selector => {
    const option1Input = selector.querySelector('.bk-media-schnuersenkel-selector__option1');
    const option2Input = selector.querySelector('.bk-media-schnuersenkel-selector__option2');
    
    if (!option1Input || !option2Input) return;
    
    const formId = option1Input.getAttribute('form');
    let form = null;
    
    if (formId) {
      form = document.getElementById(formId);
    }
    
    if (!form) {
      form = formElement.closest('form[is="product-form"]') || document.querySelector('form[is="product-form"]');
    }
    
    if (!form || (formElement && form !== formElement)) return;
    
    const schnuersenkelBildInput = form.querySelector('input[name="properties[Schnürsenkel Bild]"]');
    if (schnuersenkelBildInput) schnuersenkelBildInput.remove();
    
    if (option1Input.value) {
      let existingInput = form.querySelector(`input[name="properties[Farbe]"]`);
      if (existingInput) {
        existingInput.value = option1Input.value;
      } else {
        existingInput = document.createElement('input');
        existingInput.type = 'hidden';
        existingInput.name = 'properties[Farbe]';
        existingInput.value = option1Input.value;
        form.appendChild(existingInput);
      }
    }
    
    if (option2Input.value) {
      let existingInput = form.querySelector(`input[name="properties[Spitze]"]`);
      if (existingInput) {
        existingInput.value = option2Input.value;
      } else {
        existingInput = document.createElement('input');
        existingInput.type = 'hidden';
        existingInput.name = 'properties[Spitze]';
        existingInput.value = option2Input.value;
        form.appendChild(existingInput);
      }
    }
    
  });
}

function interceptProductFormSubmit() {
  const productForms = document.querySelectorAll('form[is="product-form"]');
  
  productForms.forEach(form => {
    if (form.dataset.schnuersenkelIntercepted) return;
    form.dataset.schnuersenkelIntercepted = 'true';
    
    form.addEventListener('submit', function(event) {
      ensureSchnuersenkelProperties(this);
    }, { capture: true, passive: false });
  });
}

function removeSchnuersenkelBildFromForm(form) {
  const input = form.querySelector('input[name="properties[Schnürsenkel Bild]"]');
  if (input) input.remove();
}

document.addEventListener('DOMContentLoaded', function() {
  initSchnuersenkelSelector();
  interceptProductFormSubmit();
  
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form && form.getAttribute('is') === 'product-form') {
      removeSchnuersenkelBildFromForm(form);
      ensureSchnuersenkelProperties(form);
    }
  }, { capture: true, passive: false });
});

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.bk-media-schnuersenkel-selector')) {
    setTimeout(function() {
      initSchnuersenkelSelector();
      interceptProductFormSubmit();
    }, 100);
  }
});

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.bk-media-schnuersenkel-selector')) {
    setTimeout(initSchnuersenkelSelector, 100);
  }
});
